const DATE_KEY_PATTERN = /^\d{4}-\d{2}-\d{2}/;

export const getAddItinerarySubmitLabel = (needsStay, isSaving = false) => {
  if (isSaving) return 'Saving...';
  return needsStay ? 'Next' : 'Add Event';
};

export const getDateKey = (value) => {
  if (!value) return '';
  const raw = String(value);
  if (DATE_KEY_PATTERN.test(raw)) return raw.slice(0, 10);
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '';
  const year = parsed.getFullYear();
  const month = String(parsed.getMonth() + 1).padStart(2, '0');
  const day = String(parsed.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const addDaysToDateKey = (value, days) => {
  const key = getDateKey(value);
  if (!key) return '';
  const [year, month, day] = key.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  date.setDate(date.getDate() + days);
  const nextMonth = String(date.getMonth() + 1).padStart(2, '0');
  const nextDay = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${nextMonth}-${nextDay}`;
};

const normalizeVenuePart = (value) => String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');

export const getVenueKey = (venue) => {
  const name = normalizeVenuePart(venue?.name);
  const address = normalizeVenuePart(venue?.address);
  return name || address ? `${name}|${address}` : '';
};

export const toStayDateTime = (dateKey, time) => {
  if (!dateKey || !time) return null;
  const parsed = new Date(`${dateKey}T${time}:00`);
  return Number.isNaN(parsed.getTime()) ? null : parsed.toISOString();
};

export const getTimeValue = (value, fallback) => {
  if (!value) return fallback;
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return fallback;
  return `${String(parsed.getHours()).padStart(2, '0')}:${String(parsed.getMinutes()).padStart(2, '0')}`;
};

export const getDefaultStayWindow = (itineraryItem, stayPlan) => {
  const eventDate = getDateKey(itineraryItem?.date);
  return {
    checkInDate: getDateKey(stayPlan?.check_in_date) || eventDate,
    checkOutDate: getDateKey(stayPlan?.check_out_date) || addDaysToDateKey(eventDate, 1),
    checkInTime: getTimeValue(stayPlan?.check_in_date, '14:00'),
    checkOutTime: getTimeValue(stayPlan?.check_out_date, '11:00'),
  };
};

export const findVenueHotel = (hotels, venue) => {
  const venueKey = getVenueKey(venue);
  if (!venueKey) return null;
  return (hotels || []).find((hotel) => hotel.venue_key === venueKey) || null;
};

export const getBlockingItineraryDeleteStayPlan = (itineraryItem, stayPlans) => {
  if (!itineraryItem?.id) return null;
  return (stayPlans || []).find((plan) => {
    const linkedEventIds = plan?.itinerary_event_ids || [];
    const isLinked = plan?.id === itineraryItem.stay_plan_id
      || linkedEventIds.includes(itineraryItem.id);
    const isLastLinkedEvent = !linkedEventIds.some(
      (eventId) => eventId !== itineraryItem.id
    );
    const hasAssignments = Number(plan?.assigned_guest_count || 0) > 0;
    return isLinked && isLastLinkedEvent && hasAssignments;
  }) || null;
};
